import axios from '../setup/axios';

export default function initFavorites() {
    document.querySelectorAll('.addToFavorites').forEach($addToFavoritesButton => {
        $addToFavoritesButton.addEventListener('click', event => {
            let currentButton = event.currentTarget;
            let pimDeviceId = currentButton.dataset.productId;
            axios
                .post('/o/favorites/addFavorite/' + pimDeviceId)
                .then(() => {
                    console.info(pimDeviceId + 'is added to favorites');
                    currentButton.hidden = true;

                    let removeFavoriteButtonList = document.querySelectorAll('.removeFavorites');
                    if (removeFavoriteButtonList.length > 0) {
                        removeFavoriteButtonList[0].hidden = false;
                    }
                })
                .catch(error => console.error(error));
        });
    });

    document.querySelectorAll('.removeFavorites').forEach($removeFavoritesButton => {
        $removeFavoritesButton.addEventListener('click', event => {
            let currentButton = event.currentTarget;
            let pimDeviceId = currentButton.dataset.productId;
            axios
                .delete('/o/favorites/deleteFavorite/' + pimDeviceId)
                .then(() => {
                    console.info(pimDeviceId + 'is removed from favorites');
                    currentButton.hidden = true;

                    let addToFavoritesButtonList = document.querySelectorAll('.addToFavorites');
                    if (addToFavoritesButtonList.length > 0) {
                        addToFavoritesButtonList[0].hidden = false;
                    }
                })
                .catch(error => console.error(error));
        });
    });
}
